/**
 * Gobo projector calculator.
 *
 * Each lens value rendered by snippets/projector-calculator.liquid is an
 * image-to-distance RATIO, so projected diameter = ratio * distance. A card
 * qualifies when the requested distance sits inside that projector's own
 * min/max throw AND at least one of its lenses reaches the requested diameter.
 *
 * The lens marked as the match is the SMALLEST one that still covers the
 * request: the tightest lens that does the job puts the same light through a
 * smaller image, so it is the brightest option.
 *
 * Until the first search the cards show each lens's ratio (its diameter at 1 m),
 * which is what the label says. After a search they show the diameter at the
 * distance actually entered.
 */
(function () {
  var form = document.querySelector('[data-projector-calculator]');
  if (!form) return;

  var root = form.closest('.hub-calc');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-calc-card]'));
  var empty = root.querySelector('[data-calc-empty]');
  var summary = root.querySelector('[data-calc-summary]');

  // Both sentences come from the locale file through the form's data attributes, with the
  // numbers left as markers for us to fill in — see snippets/projector-calculator.liquid.
  function sentence(count, size, distance) {
    var template = form.getAttribute(count === 1 ? 'data-msg-summary-one' : 'data-msg-summary-other') || '';
    return template
      .split('%COUNT%').join(count)
      .split('%SIZE%').join(size)
      .split('%DISTANCE%').join(distance);
  }

  var round = function (n) {
    return Math.round(n * 100) / 100;
  };

  function reset() {
    cards.forEach(function (card) {
      card.hidden = false;
      card.classList.remove('hub-calc__card--match');
      card.querySelectorAll('[data-lens]').forEach(function (lens) {
        lens.classList.remove('hub-calc__lens--match');
        lens.querySelector('[data-lens-size]').textContent = lens.dataset.ratio;
      });
    });
    if (empty) empty.hidden = true;
    if (summary) summary.textContent = '';
  }

  function search(size, distance) {
    var matches = 0;

    cards.forEach(function (card) {
      var min = parseFloat(card.dataset.min);
      var max = parseFloat(card.dataset.max);
      var lenses = Array.prototype.slice.call(card.querySelectorAll('[data-lens]'));
      var inRange = !(distance < min || distance > max);
      var best = null;

      lenses.forEach(function (lens) {
        var projected = parseFloat(lens.dataset.ratio) * distance;
        lens.querySelector('[data-lens-size]').textContent = round(projected);
        lens.classList.remove('hub-calc__lens--match');
        // Smallest lens that still covers the requested diameter.
        if (inRange && projected >= size && (!best || projected < best.projected)) {
          best = { el: lens, projected: projected };
        }
      });

      if (best) {
        best.el.classList.add('hub-calc__lens--match');
        card.classList.add('hub-calc__card--match');
        card.hidden = false;
        matches += 1;
      } else {
        card.classList.remove('hub-calc__card--match');
        card.hidden = true;
      }
    });

    if (empty) empty.hidden = matches > 0;
    if (summary) {
      summary.textContent = matches ? sentence(matches, size, distance) : '';
    }
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var size = parseFloat(form.elements.size.value);
    var distance = parseFloat(form.elements.distance.value);
    if (!(size > 0) || !(distance > 0)) {
      reset();
      if (summary) summary.textContent = form.getAttribute('data-msg-invalid') || '';
      return;
    }
    search(size, distance);
  });

  // `reset` fires before the inputs revert to their defaults, so defer.
  form.addEventListener('reset', function () {
    window.setTimeout(reset, 0);
  });
})();
